export default __webpack_public_path__ + "static/media/CV_Adrien_BASSET.cb7bc747.pdf";